import React from 'react';
import { Box, SxProps, Typography, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { CustomAvatar } from '../../molecules';

export type UtilisateurChoice = {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
};

export type UtilisateurChoiceItemProps = {
    user: UtilisateurChoice;
    onSelectUser: (choice?: UtilisateurChoice) => void;
    selected: boolean;
    sx?: SxProps;
    userInfo?: string | null;
};

export const UtilisateurChoiceItem: React.FunctionComponent<UtilisateurChoiceItemProps> =
    function ({ user, onSelectUser, selected, sx, userInfo }) {
        const { palette } = useTheme();

        const handleClick = () => {
            if (selected) {
                onSelectUser(undefined);
            } else {
                onSelectUser(user);
            }
        };

        return (
            <Box
                data-testid="user-choice-item"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="start"
                onClick={() => handleClick()}
                sx={{
                    margin: '0px',
                    marginBottom: '8px',
                    padding: '8px',
                    backgroundColor: selected ? palette.primary.light : palette.background.default,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    ...sx,
                }}
            >
                {/* Base container */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        width: '100%',
                        transition: 'all ease-in-out 300ms',
                    }}
                >
                    {selected && (
                        <FaOptionIcon
                            icon={['fas', 'check']}
                            sx={{ color: palette.primary.main }}
                        />
                    )}

                    {/* Avatar container */}
                    <Box
                        sx={{
                            marginRight: '20px',
                        }}
                    >
                        <CustomAvatar
                            firstName={user.firstName}
                            lastName={user.lastName}
                            sx={{
                                width: 35,
                                height: 35,
                                borderRadius: '6px',
                                fontSize: '15px',
                            }}
                        />
                    </Box>

                    {/* Name + Mail container */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            width: '100%',
                        }}
                    >
                        <Typography
                            variant="l2dh7"
                            sx={{ lineHeight: '1.4' }}
                        >
                            {user.firstName} {user.lastName}
                        </Typography>

                        {userInfo && (
                            <Typography
                                variant="l2dbodyxs"
                                color="text.gris50"
                            >
                                {userInfo}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Box>
        );
    };
